/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import { Field } from 'Util/Query';

/** @namespace Bookland/Query/Label/Query */
export class LabelQuery {
    getLabels() {
        return new Field('sf_LabelsData')
            .addFieldList(this._getLabelsFields());
    }

    _getLabelsFields() {
        return [
            'background_color',
            'css_class',
            'font_color',
            'id',
            'name',
            'position',
            'show_discount',
            'visible_in_listing'
        ];
    }
}

export default new LabelQuery();
